import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tx-document-action-dialog',
  templateUrl: './document-action-dialog.component.html',
  styleUrls: ['./document-action-dialog.component.scss']
})
export class DocumentActionDialogComponent implements OnInit {

  @Input() action: string;
  @Input() fileName: string;

  constructor(public activeModal: NgbActiveModal) {
    this.action = '';
    this.fileName = '';
   }

  ngOnInit(): void {
  }

}
